import * as React from 'react';

interface ModalProps {
    id: string;
    css?: string;
    modalTitle?: string;
    modalBody: JSX.Element;
    modalFooter?: JSX.Element;
    modalSize?: string;
    modalHeight?: number;
    onDismiss?: () => void;
}

class Modal extends React.Component<ModalProps> {
    constructor(props: ModalProps) {
        super(props);
    }

    render() {
        return (
            <div id={this.props.id} className={'modal fade'} role="dialog" data-backdrop="static" data-keyboard="false">
                <div
                    className={
                        this.props.modalSize !== undefined ? 'modal-dialog ' + this.props.modalSize : 'modal-dialog'
                    }
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{this.props.modalTitle}</h5>
                            <a
                                className="close"
                                data-dismiss="modal"
                                onClick={(event: React.MouseEvent<HTMLElement>) => {
                                    this.props.onDismiss !== undefined ? this.props.onDismiss() : this.doNothing(event);
                                }}
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </a>
                        </div>

                        <div className="modal-body">{this.props.modalBody}</div>

                        <div className="modal-footer">{this.props.modalFooter}</div>
                    </div>
                </div>
            </div>
        );
    }

    doNothing(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/modal.tsx